import { validateEmail } from './helpers';

class Validations {
  errorMsg = '';
  validations: Function[] = [];

  pushValidation(validationFn) {
    this.validations.push(validationFn);
  }

  required(errorMsg = '') {
    this.pushValidation((value) => (!value?.toString().trim() ? errorMsg : ''));
    return this;
  }

  requiredEach(errorMsg = '') {
    this.pushValidation((value: []) => value.map((item) => (!item ? errorMsg : '')));
    return this;
  }

  email(errorMsg = '') {
    this.pushValidation((value) => (!validateEmail(value) ? errorMsg : ''));
    return this;
  }

  exist(errorMsg = '') {
    this.pushValidation((value) => (!value ? errorMsg : ''));
    return this;
  }

  empty(errorMsg = '') {
    this.pushValidation((value) => (!value.length ? errorMsg : ''));
    return this;
  }

  minLength(errorMsg = '', length = 3) {
    this.pushValidation((value) => (value?.trim().length <= length ? errorMsg : ''));
    return this;
  }

  maxLength(errorMsg = '', length = 200) {
    this.pushValidation((value) => (value?.trim().length > length ? errorMsg : ''));
    return this;
  }

  greaterThan(errorMsg = '', min) {
    this.pushValidation((value) => (value <= min ? errorMsg : ''));
    return this;
  }

  lessThan(errorMsg = '', min) {
    this.pushValidation((value) => (value > min ? errorMsg : ''));
    return this;
  }

  match(regExp, errorMsg = '') {
    this.pushValidation((value) => (!value?.trim().match(regExp) ? errorMsg : ''));
    return this;
  }

  run(value) {
    this.errorMsg = this.validations.reduce((acc, validation) => {
      if (!acc) {
        return validation(value);
      } else return acc;
    }, '');
    return this;
  }
}

export const createValidation = () => new Validations();

interface ISchema {
  [key: string]: Validations;
}

export const createSchema = (schema: ISchema) => ({
  cast: <T>(fields: T) => {
    const errors: Partial<T> = Object.entries(fields).reduce((accErrors, [key, value]) => {
      const validations = schema[key];

      if (!validations) {
        return accErrors;
      }

      const validated = validations?.run(value);

      if (validated?.errorMsg) {
        return { ...accErrors, [key]: validated.errorMsg };
      } else {
        return accErrors;
      }
    }, {});

    return errors;
  },
});
